export default __webpack_public_path__ + "static/media/slider-13.10332f96.jpg";